module.exports = __webpack_public_path__ + "static/media/2-placeholder.26ce1b46.gif";